export default __webpack_public_path__ + "static/SamsungOneUI-500-25a2883a95512df3c3e50fed24e587c5.ttf";